<template>
  <div class="field">
    <label class="label" :for="id">{{ inputName }}</label>
    <div
      class="control"
      :class="
        icons && icons.left
          ? 'has-icons-left'
          : icons && icons.right
          ? 'has-icons-right'
          : ''
      "
    >
      <input
        :id="id"
        class="input"
        :class="field.error ? 'is-danger' : ''"
        :type="type"
        :placeholder="placeholder"
        v-model="field.value"
        @change="modified"
        @keyup="format"
        v-on:keyup.enter="enter"
        :autocomplete="autocomplete ? autocomplete : 'off'"
      />
      <span class="icon is-small is-left" v-if="icons && icons.left">
        <i class="fas" :class="icons.left"></i>
      </span>
      <span class="icon is-small is-right" v-if="icons && icons.right">
        <i class="fas" :class="icons.right"></i>
      </span>
    </div>
    <p class="help is-danger" v-if="field.error">{{ field.error }}</p>
  </div>
</template>

<script>
export default {
  name: "Input",
  model(defaultValue) {
    return {
      value: defaultValue ? defaultValue : "",
      error: null,
      typed: false,
    };
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
    obj: String,
    icons: Object,
    placeholder: String,
    range: Array,
    autocomplete: String,
  },
  data() {
    return {
      field: this.inputField,
      model_obj: this.obj,
      id: null
    };
  },
  computed: {
    type: function () {
      let t = "text";
      switch (this.inputType) {
        case "currency":
        case "percent":
        case "phone":
        case "ein":
        case "ssn":
        case "year":
        case "zip":
          t = "tel";
          break;
        case "pass":
          t = "password";
          break;
        case "email":
          t = "email";
          break;
        case "url":
          t = "url";
          break;
      }
      return t;
    },
  },
  mounted: function () {
    var self = this;
    if (this.field.value) {
      self.format();
      self.validate();
    }
    this.id = this._uid
  },
  methods: {
    enter() {
      console.log("pressed enter");
      this.$emit("enter", this.$data);
    },
    modified() {
      this.field.typed = true;
      this.validate();
    },
    validate() {
      // console.log("validating");
      this.field.error = null;

      if (this.inputType == "string_empty") {
        // console.log("string_empty type");
        this.field.value = this.field.value.toString().trim();
        return this.field.error == null;
      }

      // validation rules
      if (!this.field.value) {
        this.field.error = "This field can't be empty";
        return false;
      }
      let regex = new RegExp("^[a-zA-Z0-9s.-]+$");
      // console.log("validating", this.inputType);
      switch (this.inputType) {
        case "string":
          if (this.field.value.length < 2) {
            this.field.error = "Please enter a valid " + this.inputName;
          }

          break;

        case "singlestring":
          if (this.field.value.length < 2 || !regex.test(this.field.value)) {
            this.field.error = "Please enter a valid " + this.inputName;
          }

          break;

        case "currency":
          let str = this.field.value.toString().replace(/\D/g, "");

          regex = new RegExp("^[0-9]*$");
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid amount";
          }
          break;

        case "phone":
          str = this.field.value.toString().replace(/\D/g, "");

          regex = new RegExp("^[0-9]{10}$");
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid phone number";
          }
          break;

        case "email":
          str = this.field.value.trim();

          regex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid email";
          }
          break;

        case "year":
          str = this.field.value;
          regex = /^[0-9]+$/;
          const current_year = new Date().getFullYear();
          if (
            !regex.test(str) ||
            str.length != 4 ||
            str < 1700 ||
            str > current_year
          ) {
            this.field.error = "Please enter a valid year";
          }

          break;
        case "last4":
          str = this.field.value;
          regex = /^[0-9]+$/;
          if (!regex.test(str) || str.length != 4) {
            this.field.error = "Please enter a valid 4 digits.";
          }

          break;

        case "ein":
          str = this.field.value;
          regex =
            /^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/;
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid FEIN";
          }
          break;

        case "ssn":
          str = this.field.value;
          regex = /^\d{3}-\d{2}-\d{4}$/;
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid SSN";
          }
          break;

        case "zip":
          str = this.field.value;
          regex = new RegExp("^[0-9]{5}$");
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid zip code";
          }
          break;

        case "state":
          str = this.field.value;
          regex =
            /^((AL)|(AK)|(AS)|(AZ)|(AR)|(CA)|(CO)|(CT)|(DE)|(DC)|(FM)|(FL)|(GA)|(GU)|(HI)|(ID)|(IL)|(IN)|(IA)|(KS)|(KY)|(LA)|(ME)|(MH)|(MD)|(MA)|(MI)|(MN)|(MS)|(MO)|(MT)|(NE)|(NV)|(NH)|(NJ)|(NM)|(NY)|(NC)|(ND)|(MP)|(OH)|(OK)|(OR)|(PW)|(PA)|(PR)|(RI)|(SC)|(SD)|(TN)|(TX)|(UT)|(VT)|(VI)|(VA)|(WA)|(WV)|(WI)|(WY))$/;
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid state";
          }
          break;

        case "url":
          str = this.field.value;
          regex = new RegExp(
            "^((((H|h)(T|t)|(F|f))(T|t)(P|p)((S|s)?))://)?(www.|[a-zA-Z0-9].)[a-zA-Z0-9-.]+.[a-zA-Z]{2,6}(:[0-9]{1,5})*(/($|[a-zA-Z0-9.,;?'\\+&amp;%$#=~_-]+))*$"
          );
          if (!regex.test(str)) {
            this.field.error = "Please enter a valid URL";
          }
          break;
      }

      // range validation
      if (this.range) {
        if (
          parseInt(this.field.value.toString().replace(/\D/g, "")) <
            this.range[0] ||
          parseInt(this.field.value.toString().replace(/\D/g, "")) >
            this.range[1]
        ) {
          this.field.error =
            "Please enter a value between " +
            this.numberWithCommas(this.range[0], false) +
            " and " +
            this.numberWithCommas(this.range[1], false);
          switch (this.inputType) {
            case "currency":
              this.field.error =
                "Please enter an amount between $" +
                this.numberWithCommas(this.range[0], true) +
                " and $" +
                this.numberWithCommas(this.range[1], true);
              break;
            case "percent":
              this.field.error =
                "Please enter a percentage between " +
                this.range[0] +
                "% and " +
                this.range[1] +
                "%";
              break;
          }
        }
      }
      this.field.value = this.field.value.toString().trim();
      return this.field.error == null;
    },
    numberWithCommas(val, money = true) {
      if (money) val = parseFloat(val).toFixed(2);
      var returnval = null;
      if (val != null)
        returnval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (returnval == "NaN") returnval = "0.00";

      return returnval;
    },
    setValue(s) {
      this.field.value = s;
      this.modified();
    },
    format() {
      // console.log("formatting for " + this.inputType);
      var newval = this.field.value;
      var x = this.field.value;
      if (x == null || x == "") {
        return;
      }
      switch (this.inputType) {
        case "currency":
          newval = x
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          break;
        case "phone":
          let input = x.toString().replace(/\D/g, "");
          input = input.substring(0, 10);
          var size = input.length;
          if (size == 0) {
            input = input;
          } else if (size < 4) {
            input = "(" + input;
          } else if (size < 7) {
            input = "(" + input.substring(0, 3) + ") " + input.substring(3, 6);
          } else {
            input =
              "(" +
              input.substring(0, 3) +
              ") " +
              input.substring(3, 6) +
              "-" +
              input.substring(6, 10);
          }
          newval = input;
          break;
        case "ssn":
          var val = x.toString().replace(/\D/g, "");
          val = val.substring(0, 9);
          var newVal = "";

          if (val.length > 3 && val.length < 6) {
            newVal += val.substr(0, 3) + "-";
            val = val.substr(3);
          }

          if (val.length > 5) {
            newVal += val.substr(0, 3) + "-";
            newVal += val.substr(3, 2) + "-";
            val = val.substr(5);
          }

          newVal += val;
          newval = newVal;
          break;
        case "ein":
          var val = x.toString().replace(/\D/g, "");
          val = val.substring(0, 9);
          var newVal = "";

          if (val.length > 2) {
            newVal += val.substr(0, 2) + "-";
            val = val.substr(2);
          }

          newVal += val;
          newval = newVal;
          break;
        case "state":
          newval = x.toString().substring(0, 2).toUpperCase();

          break;
        case "zip":
          newval = x.toString().replace(/\D/g, "").substring(0, 5);

          break;
        case "percent":
          newval = x.toString().replace(/\D/g, "").substring(0, 3);
          if (parseInt(newval) > 100) {
            newval = 100;
          }
          if (parseInt(newval) < 1) {
            newval = 1;
          }
          break;

        case "year":
          newval = x.toString().replace(/\D/g, "").substring(0, 4);

          var dt = new Date();
          var currentYear = dt.getFullYear();

          if (parseInt(newval) > currentYear) {
            newval = currentYear;
          }

          break;
        case "email":
        case "url":
          newval = x.toLowerCase();
          break;
        case "name":
          newval = x.toString();
          if (x.length > 0) {
            let temp = x.split(' ').map(word => 
                word.charAt(0).toUpperCase() + word.slice(1)
            ).join(' ');
            
            newval = temp.replace(" Llc", " LLC");
            newval = newval.replace(" Of ", " of ");
            newval = newval.replace(" Inc ", " INC ");
            // newval = x.charAt(0).toUpperCase() + x.substr(1).toLowerCase();
            // newval = x.replace(/^./, x[0].toUpperCase());
          }
          break;
      }

      this.field.value = newval;
    },
  },
};
</script>

<style scoped>
.control.has-icons-left .icon.is-left {
  top: 3px;
}

.control.has-icons-right .icon.is-right {
  top: 3px;
}
</style>
